webpackJsonp([1],{

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DecodeTokenPage_vue__ = __webpack_require__(277);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7989e08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DecodeTokenPage_vue__ = __webpack_require__(300);
function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var normalizeComponent = __webpack_require__(106)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DecodeTokenPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7989e08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DecodeTokenPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9dffe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31e9dffe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CustomStyle',
  mounted: function mounted() {
    var styleTag = document.createElement('style');
    styleTag.textContent = this.$refs.styles.textContent;
    this.$refs.styles.textContent = null;
    this.$refs.styles.appendChild(styleTag);
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"styles",staticStyle:{"display":"none"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ManageTokenService__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_LayoutWrapper__ = __webpack_require__(291);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DecodeTokenPage",
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  components: { LayoutWrapper: __WEBPACK_IMPORTED_MODULE_4__components_Common_LayoutWrapper__["a" /* default */] },
  props: {
    token: {
      type: String,
      default: ""
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = _this.token || __WEBPACK_IMPORTED_MODULE_3__services_ManageTokenService__["a" /* default */].getTokenFromStorage();


              window.addEventListener("pageshow", function (event) {
                if (event.persisted && !token) {
                  // strona załadowana z pamieci podrecznej przegladarki
                  redirectWhenTokenIsNotPresent();
                }
              });

              if (!token) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return _this.$store.dispatch("authServicesPoints/getAuthServicePointSettingsByToken", token);

            case 5:
              _context.next = 9;
              break;

            case 7:
              _this.redirectWhenTokenIsNotPresent();
              return _context.abrupt("return");

            case 9:

              if (_this.$store.getters["authServicesPoints/tokenIsValid"]) {
                __WEBPACK_IMPORTED_MODULE_3__services_ManageTokenService__["a" /* default */].addTokenToStorage(token);
                _this.$router.push({ path: "/auth" });
              } else {
                __WEBPACK_IMPORTED_MODULE_3__services_ManageTokenService__["a" /* default */].removeTokenFromStorage();
                _this.$router.push({ path: "/error" });
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    redirectWhenTokenIsNotPresent: function redirectWhenTokenIsNotPresent() {
      if (document.URL.includes("whitephone")) {
        if (document.URL.includes("staging")) {
          window.location.replace("https://staging.system.whitephone.pl");
        } else {
          window.location.replace("https://system.whitephone.pl");
        }
      } else {
        this.$store.dispatch("authServicesPoints/setStateForWaitingForAuthServicePointData", false);
        this.$router.push({ path: "/info" });
      }
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Common_CustomStyle__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Common_AppVersion__ = __webpack_require__(294);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LayoutWrapper',
  components: {
    CustomStyle: __WEBPACK_IMPORTED_MODULE_0__components_Common_CustomStyle__["a" /* default */],
    AppVersion: __WEBPACK_IMPORTED_MODULE_1__components_Common_AppVersion__["a" /* default */]
  },
  props: {
    brandTheme: Object,
    brandLogo: String,
    logoAboveForm: String,
    supportEmail: null
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppVersion',

  data: function data() {
    return {
      version: "staging - Thu Feb 12 22:14:16 UTC 2026"
    };
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("14dbdf34", content, true, {});

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.DecodeTokenPageView{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/views/DecodeTokenPage.vue"],"names":[],"mappings":"AACA,2BACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mBACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,qBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,aAAc,AACd,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC","file":"DecodeTokenPage.vue","sourcesContent":["\n@-webkit-keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.DecodeTokenPageView {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ec19cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(298);
function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10ec19cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10ec19cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(293);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("214fc4e8", content, true, {});

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-10ec19cc{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-10ec19cc{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}[data-v-10ec19cc]{-webkit-box-sizing:border-box;box-sizing:border-box}.LayoutWrapper[data-v-10ec19cc],.LayoutWrapper__content[data-v-10ec19cc]{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.LayoutWrapper__content[data-v-10ec19cc]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}@media screen and (max-width:648px){.LayoutWrapper__content[data-v-10ec19cc]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.LayoutWrapper__column[data-v-10ec19cc]{height:100%;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow-y:auto;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:0;-ms-flex:1 1 50%;flex:1 1 50%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media screen and (max-width:648px){.LayoutWrapper__column[data-v-10ec19cc]{width:100%;height:auto}}.LayoutWrapper__column--left[data-v-10ec19cc]{height:100vh;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-shadow:0 10px 8px 0 rgba(38,36,37,.32);box-shadow:0 10px 8px 0 rgba(38,36,37,.32);z-index:2}@media screen and (max-width:648px){.LayoutWrapper__column--left[data-v-10ec19cc]{padding:30px 0}}.LayoutWrapper__logo[data-v-10ec19cc]{width:100%;text-align:center}.LayoutWrapper__logo-above-form[data-v-10ec19cc]{margin:0 auto;display:block;padding:0 10px;max-width:100%}.LayoutWrapper__logo-image[data-v-10ec19cc]{width:70%}.LayoutWrapper__inner[data-v-10ec19cc]{width:100%;max-width:500px;padding:25px 0}.LayoutWrapper__form[data-v-10ec19cc]{padding:0 10px}.LayoutWrapper__contact-content[data-v-10ec19cc]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;max-width:500px;text-align:center;border-top:1px solid #61656e;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:50px 0 0}.LayoutWrapper__contact-column[data-v-10ec19cc]{display:inline-block}.LayoutWrapper__contact-column--left[data-v-10ec19cc]{margin-right:5px;color:#f6a821}.LayoutWrapper__contact-column--right[data-v-10ec19cc]{margin-left:5px}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/Common/LayoutWrapper/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,kBACE,8BAA+B,AACvB,qBAAuB,CAChC,AAUD,yEARE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,aAAc,AACd,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CAgBxB,AAdD,yCAQI,mBAAoB,AAChB,eAAgB,AACpB,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAC/B,AACD,oCACA,yCACQ,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CACtC,CACA,AACD,wCACI,YAAa,AACb,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,aAAc,AACd,iBAAkB,AACd,aAAc,AAClB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,oCACA,wCACQ,WAAY,AACZ,WAAa,CACpB,CACA,AACD,8CACI,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mDAA4D,AACpD,2CAAoD,AAC5D,SAAW,CACd,AACD,oCACA,8CACQ,cAAkB,CACzB,CACA,AACD,sCACI,WAAY,AACZ,iBAAmB,CACtB,AACD,iDACI,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,cAAgB,CACnB,AACD,4CACI,SAAW,CACd,AACD,uCACI,WAAY,AACZ,gBAAiB,AACjB,cAAkB,CACrB,AACD,sCACI,cAAkB,CACrB,AACD,iDACI,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,6BAA8B,AAC9B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAA0B,CAC7B,AACD,gDACI,oBAAsB,CACzB,AACD,sDACI,iBAAkB,AAClB,aAAe,CAClB,AACD,uDACI,eAAiB,CACpB","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-10ec19cc {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-10ec19cc {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n*[data-v-10ec19cc] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.LayoutWrapper[data-v-10ec19cc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n.LayoutWrapper__content[data-v-10ec19cc] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    min-height: 0;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n@media screen and (max-width: 648px) {\n.LayoutWrapper__content[data-v-10ec19cc] {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n}\n}\n.LayoutWrapper__column[data-v-10ec19cc] {\n    height: 100%;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    overflow-y: auto;\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    min-height: 0;\n    -ms-flex: 1 1 50%;\n        flex: 1 1 50%;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n@media screen and (max-width: 648px) {\n.LayoutWrapper__column[data-v-10ec19cc] {\n        width: 100%;\n        height: auto;\n}\n}\n.LayoutWrapper__column--left[data-v-10ec19cc] {\n    height: 100vh;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-shadow: 0px 10px 8px 0px rgba(38, 36, 37, 0.32);\n            box-shadow: 0px 10px 8px 0px rgba(38, 36, 37, 0.32);\n    z-index: 2;\n}\n@media screen and (max-width: 648px) {\n.LayoutWrapper__column--left[data-v-10ec19cc] {\n        padding: 30px 0px;\n}\n}\n.LayoutWrapper__logo[data-v-10ec19cc] {\n    width: 100%;\n    text-align: center;\n}\n.LayoutWrapper__logo-above-form[data-v-10ec19cc] {\n    margin: 0 auto;\n    display: block;\n    padding: 0 10px;\n    max-width: 100%;\n}\n.LayoutWrapper__logo-image[data-v-10ec19cc] {\n    width: 70%;\n}\n.LayoutWrapper__inner[data-v-10ec19cc] {\n    width: 100%;\n    max-width: 500px;\n    padding: 25px 0px;\n}\n.LayoutWrapper__form[data-v-10ec19cc] {\n    padding: 0px 10px;\n}\n.LayoutWrapper__contact-content[data-v-10ec19cc] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    max-width: 500px;\n    text-align: center;\n    border-top: 1px solid #61656e;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding: 50px 0px 0px 0px;\n}\n.LayoutWrapper__contact-column[data-v-10ec19cc] {\n    display: inline-block;\n}\n.LayoutWrapper__contact-column--left[data-v-10ec19cc] {\n    margin-right: 5px;\n    color: #f6a821;\n}\n.LayoutWrapper__contact-column--right[data-v-10ec19cc] {\n    margin-left: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c5b1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(297);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(106)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-598c5b1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c5b1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(268)("18f88df1", content, true, {});

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(267)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-598c5b1c{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-598c5b1c{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.AppVersion[data-v-598c5b1c]{position:absolute;right:5px;bottom:5px;font-size:12px;font-weight:300;color:hsla(0,0%,100%,.6)}", "", {"version":3,"sources":["/builds/Microservices/ms-auth.internal01.tls.sh/platform/src/components/Common/AppVersion/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,6BACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,eAAgB,AAChB,gBAAiB,AACjB,wBAAgC,CACjC","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-598c5b1c {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-598c5b1c {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.AppVersion[data-v-598c5b1c] {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  font-size: 12px;\n  font-weight: 300;\n  color: rgba(255, 255, 255, 0.6);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppVersion"},[_vm._v("\n  version: "+_vm._s(_vm.version)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LayoutWrapper"},[_c('CustomStyle',[_vm._v("\n    "+_vm._s(this.brandTheme.layout)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"LayoutWrapper__content"},[_c('div',{staticClass:"LayoutWrapper__column LayoutWrapper__column--left"},[_c('div',{staticClass:"LayoutWrapper__logo animated fadeInLeft"},[(!_vm.brandLogo)?_c('img',{staticClass:"LayoutWrapper__logo-image",attrs:{"src":__webpack_require__(299)}}):_vm._e(),_vm._v(" "),(_vm.brandLogo)?_c('img',{staticClass:"LayoutWrapper__logo-image",attrs:{"src":_vm.brandLogo}}):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.getters['global/pendingAsyncStoreActions'].includes([
        'loginToASP', 'registerToASP', 'changePasswordToASP', 'confirmChangePasswordToASP'
      ])),expression:"$store.getters['global/pendingAsyncStoreActions'].includes([\n        'loginToASP', 'registerToASP', 'changePasswordToASP', 'confirmChangePasswordToASP'\n      ])"}],staticClass:"LayoutWrapper__column LayoutWrapper__column--right",attrs:{"element-loading-text":"Trwa przekazywanie danych"}},[_c('div',{staticClass:"LayoutWrapper__inner"},[(_vm.logoAboveForm)?_c('img',{staticClass:"LayoutWrapper__logo-above-form",attrs:{"alt":"logo","src":_vm.logoAboveForm}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"LayoutWrapper__form"},[_vm._t("views")],2),_vm._v(" "),_c('div',{staticClass:"LayoutWrapper__contact-content"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"LayoutWrapper__contact-column LayoutWrapper__contact-column--right"},[_vm._v("\n            "+_vm._s(_vm.supportEmail)+"\n          ")])])])])]),_vm._v(" "),_c('AppVersion')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"LayoutWrapper__contact-column LayoutWrapper__contact-column--left"},[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" "),_c('span',{staticClass:"LayoutWrapper__contact-description"},[_vm._v("\n              Kontakt\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-grupy-call contact.1a74420.png";

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.$store.getters['authServicesPoints/isWaitingForAuthServicePointData']),expression:"$store.getters['authServicesPoints/isWaitingForAuthServicePointData']",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"DecodeTokenPageView view",attrs:{"element-loading-text":"Pobieranie danych","element-loading-background":"rgba(45, 47, 66, 1)"}},[(!_vm.$store.getters['authServicesPoints/isWaitingForAuthServicePointData'])?_c('LayoutWrapper',{attrs:{"brandTheme":_vm.$store.getters['global/brandTheme'],"brandLogo":_vm.$store.getters['global/brandLogo'],"logoAboveForm":_vm.$store.getters['global/logoAboveForm'],"supportEmail":_vm.$store.getters['global/supportEmail']}},[_c('router-view',{attrs:{"slot":"views"},slot:"views"})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.3a3035cc737d760782c3.js